import { createRoot } from 'react-dom/client';
import { PostHogErrorBoundary, PostHogProvider } from '@posthog/react';
import posthog from 'posthog-js';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// third-party
import 'regenerator-runtime/runtime';

// the two families, served from the app's origin: Inter upright and italic with its optical-size axis, Roboto Mono
import '@fontsource-variable/inter/opsz.css';
import '@fontsource-variable/inter/opsz-italic.css';
import '@fontsource-variable/roboto-mono';

// tailwind entry: the tokens, Preflight and the utilities
import './index.css';

// scroll bar
import 'simplebar/src/simplebar.css';

// apex-chart

// project import
import RouteErrorPage from 'pages/error/RouteErrorPage';
import App from './App';

import { initMonitoring, logError } from 'utils/monitoring';
import { initPostHog, isPostHogEnabled } from 'utils/posthog';
import reportWebVitals from './reportWebVitals';

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //

initMonitoring();
initPostHog();

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container, {
    // React 19 hands uncaught render errors to this callback instead of re-throwing them, so they
    // no longer reach window.onerror — the path Datadog captured them on, with a real Error and a
    // stack. Without this they arrive only as forwarded console.error text.
    onUncaughtError: (error, errorInfo) => logError(error, { componentStack: errorInfo.componentStack }),
});
const router = createBrowserRouter([{ path: '*', element: <App />, errorElement: <RouteErrorPage /> }]);

root.render(
    isPostHogEnabled ? (
        <PostHogProvider client={posthog}>
            <PostHogErrorBoundary>
                <RouterProvider router={router} />
            </PostHogErrorBoundary>
        </PostHogProvider>
    ) : (
        <RouterProvider router={router} />
    )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
